'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var store$1 = require('@component-controls/store');

var bundle = require('component-controls-bundle');

var store = store$1.loadStore(bundle, true);
exports.store = store;